import { StudioSection } from './StudioSection';
import { PlaceTitleControls } from './PlaceTitleControls';
import type { PlaceTitleSettings } from './place-title-settings';

export function PlaceTitleSection({ value, open, onToggle, onChange, replaying, onReplay }: {
  value: PlaceTitleSettings; open: boolean; onToggle: (open: boolean) => void;
  onChange: (value: PlaceTitleSettings) => void; replaying: boolean; onReplay: () => void;
}) {
  const summary = value.lookup === 'pending' ? 'Finding place…' : value.enabled ? value.name || 'Enter a place name' : 'Off';
  return <StudioSection title="Place title" summary={summary} open={open} onToggle={onToggle}>
    <PlaceTitleControls value={value} onChange={next => onChange({ ...next, lookup: 'custom' })}
      onLookup={() => onChange({ ...value, enabled: true, lookup: 'pending' })} replaying={replaying} onReplay={onReplay} />
  </StudioSection>;
}
